import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/app/_layout/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[locale]/(web)/(session)/_assets/chess-bg.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/(session)/_BenefitSection/index.tsx");
